@if (!('workflow.status.change'|HasPerm)) {
  @switch (workflow.status) {
    @case (0) {
      <span class="label label-default">Unbearbeitet</span>
    }
    @case (1) {
      <span class="label label-default">Offen</span>
    }
    @case (2) {
      <span class="label label-info">Auftrag</span>
    }
    @case (3) {
      <span class="label label-primary">Bestätigt</span>
    }
    @case (4) {
      <span class="label label-warning">Geliefert</span>
    }
    @case (5) {
      <span class="label label-success">Abgerechnet</span>
    }
    @case (100) {
      <span class="label label-danger">Storniert</span>
    }
    @case (101) {
      <span class="label label-danger">Gelöscht</span>
    }
  }
}

@if (('workflow.status.change'|HasPerm)) {
  @switch (workflow.status) {
    @case (0) {
      <span class="label label-default click" (click)="open()">Unbearbeitet</span>
    }
    @case (1) {
      <span class="label label-default click" (click)="open()">Offen</span>
    }
    @case (2) {
      <span class="label label-info click" (click)="open()">Auftrag</span>
    }
    @case (3) {
      <span class="label label-primary click" (click)="open()">Bestätigt</span>
    }
    @case (4) {
      <span class="label label-warning click" (click)="open()">Geliefert</span>
    }
    @case (5) {
      <span class="label label-success click" (click)="open()">Abgerechnet</span>
    }
    @case (100) {
      <span class="label label-danger click" (click)="open()">Storniert</span>
    }
    @case (101) {
      <span class="label label-danger click" (click)="open()">Gelöscht</span>
    }
  }
}
